import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminRules: build.query<
      GetV2AdminRulesApiResponse,
      GetV2AdminRulesApiArg
    >({
      query: () => ({ url: `/v2/admin/rules` }),
    }),
    postV2AdminRules: build.mutation<
      PostV2AdminRulesApiResponse,
      PostV2AdminRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/rules`,
        method: "POST",
        body: queryArg.createRuleRequest,
      }),
    }),
    postV2AdminRulesSearch: build.mutation<
      PostV2AdminRulesSearchApiResponse,
      PostV2AdminRulesSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/rules/search`,
        method: "POST",
        body: queryArg.ruleSearchRequest,
      }),
    }),
    deleteV2AdminRulesByRuleId: build.mutation<
      DeleteV2AdminRulesByRuleIdApiResponse,
      DeleteV2AdminRulesByRuleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/rules/${queryArg.ruleId}`,
        method: "DELETE",
      }),
    }),
    getV2AdminRulesByRuleId: build.query<
      GetV2AdminRulesByRuleIdApiResponse,
      GetV2AdminRulesByRuleIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/rules/${queryArg.ruleId}` }),
    }),
    putV2AdminRulesByRuleId: build.mutation<
      PutV2AdminRulesByRuleIdApiResponse,
      PutV2AdminRulesByRuleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/rules/${queryArg.ruleId}`,
        method: "PUT",
        body: queryArg.updateRuleRequest,
      }),
    }),
    getV2ProviderRules: build.query<
      GetV2ProviderRulesApiResponse,
      GetV2ProviderRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          scope: queryArg.scope,
          rule_type: queryArg.ruleType,
        },
      }),
    }),
    postV2ProviderRules: build.mutation<
      PostV2ProviderRulesApiResponse,
      PostV2ProviderRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules`,
        method: "POST",
        body: queryArg.providerRuleCreateRequest,
      }),
    }),
    getV2ProviderRulesSearch: build.query<
      GetV2ProviderRulesSearchApiResponse,
      GetV2ProviderRulesSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/search`,
        params: {
          q: queryArg.q,
          top_k: queryArg.topK,
          rule_type: queryArg.ruleType,
        },
      }),
    }),
    deleteV2ProviderRulesByRuleId: build.mutation<
      DeleteV2ProviderRulesByRuleIdApiResponse,
      DeleteV2ProviderRulesByRuleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/${queryArg.ruleId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderRulesByRuleId: build.query<
      GetV2ProviderRulesByRuleIdApiResponse,
      GetV2ProviderRulesByRuleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/${queryArg.ruleId}`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    putV2ProviderRulesByRuleId: build.mutation<
      PutV2ProviderRulesByRuleIdApiResponse,
      PutV2ProviderRulesByRuleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/${queryArg.ruleId}`,
        method: "PUT",
        body: queryArg.providerRuleUpdateRequest,
      }),
    }),
    postV2ProviderRulesByRuleIdDisable: build.mutation<
      PostV2ProviderRulesByRuleIdDisableApiResponse,
      PostV2ProviderRulesByRuleIdDisableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/${queryArg.ruleId}/disable`,
        method: "POST",
        body: queryArg.providerRuleDisableRequest,
      }),
    }),
    postV2ProviderRulesByRuleIdEnable: build.mutation<
      PostV2ProviderRulesByRuleIdEnableApiResponse,
      PostV2ProviderRulesByRuleIdEnableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/${queryArg.ruleId}/enable`,
        method: "POST",
        body: queryArg.providerRuleDisableRequest,
      }),
    }),
    postV2ProviderRulesByRuleIdFork: build.mutation<
      PostV2ProviderRulesByRuleIdForkApiResponse,
      PostV2ProviderRulesByRuleIdForkApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/${queryArg.ruleId}/fork`,
        method: "POST",
        body: queryArg.providerRuleForkRequest,
      }),
    }),
    postV2ProviderRulesByRuleIdRevert: build.mutation<
      PostV2ProviderRulesByRuleIdRevertApiResponse,
      PostV2ProviderRulesByRuleIdRevertApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/${queryArg.ruleId}/revert`,
        method: "POST",
        body: queryArg.providerRuleRevertRequest,
      }),
    }),
    getV2ProviderRulesByRuleIdRevisions: build.query<
      GetV2ProviderRulesByRuleIdRevisionsApiResponse,
      GetV2ProviderRulesByRuleIdRevisionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/${queryArg.ruleId}/revisions`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminRulesApiResponse = /** status 200 OK */ ListResponse;
export type GetV2AdminRulesApiArg = void;
export type PostV2AdminRulesApiResponse = /** status 200 OK */ RuleResponse;
export type PostV2AdminRulesApiArg = {
  createRuleRequest: CreateRuleRequest;
};
export type PostV2AdminRulesSearchApiResponse =
  /** status 200 OK */ RuleSearchResponse;
export type PostV2AdminRulesSearchApiArg = {
  ruleSearchRequest: RuleSearchRequest;
};
export type DeleteV2AdminRulesByRuleIdApiResponse = unknown;
export type DeleteV2AdminRulesByRuleIdApiArg = {
  ruleId: string;
};
export type GetV2AdminRulesByRuleIdApiResponse =
  /** status 200 OK */ RuleResponse;
export type GetV2AdminRulesByRuleIdApiArg = {
  ruleId: string;
};
export type PutV2AdminRulesByRuleIdApiResponse =
  /** status 200 OK */ RuleResponse;
export type PutV2AdminRulesByRuleIdApiArg = {
  ruleId: string;
  updateRuleRequest: UpdateRuleRequest;
};
export type GetV2ProviderRulesApiResponse =
  /** status 200 OK */ ProviderRuleListResponse;
export type GetV2ProviderRulesApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
  /** Filter by scope: 'global', 'org', or 'both' (default) */
  scope?: RuleScope;
  /** Filter by rule type: 'compliance' or 'learning'. If not provided, returns both types. */
  ruleType?: RuleType | null;
};
export type PostV2ProviderRulesApiResponse =
  /** status 200 OK */ ProviderRuleCreateResponse;
export type PostV2ProviderRulesApiArg = {
  providerRuleCreateRequest: ProviderRuleCreateRequest;
};
export type GetV2ProviderRulesSearchApiResponse =
  /** status 200 OK */ ProviderRuleSearchResponse;
export type GetV2ProviderRulesSearchApiArg = {
  /** Search query text */
  q: string;
  /** Number of top results to return */
  topK?: number;
  /** Filter by rule type: 'compliance' or 'learning'. If not provided, searches both types. */
  ruleType?: RuleType4 | null;
};
export type DeleteV2ProviderRulesByRuleIdApiResponse =
  /** status 200 OK */ ProviderRuleDeleteResponse;
export type DeleteV2ProviderRulesByRuleIdApiArg = {
  ruleId: string;
};
export type GetV2ProviderRulesByRuleIdApiResponse =
  /** status 200 OK */ ProviderRuleResponse2;
export type GetV2ProviderRulesByRuleIdApiArg = {
  ruleId: string;
  /** Organization ID for scoping */
  organizationId?: string | null;
};
export type PutV2ProviderRulesByRuleIdApiResponse =
  /** status 200 OK */ ProviderRuleUpdateResponse;
export type PutV2ProviderRulesByRuleIdApiArg = {
  ruleId: string;
  providerRuleUpdateRequest: ProviderRuleUpdateRequest;
};
export type PostV2ProviderRulesByRuleIdDisableApiResponse =
  /** status 200 OK */ ProviderRuleDisableResponse;
export type PostV2ProviderRulesByRuleIdDisableApiArg = {
  ruleId: string;
  providerRuleDisableRequest: ProviderRuleDisableRequest;
};
export type PostV2ProviderRulesByRuleIdEnableApiResponse =
  /** status 200 OK */ ProviderRuleDisableResponse;
export type PostV2ProviderRulesByRuleIdEnableApiArg = {
  ruleId: string;
  providerRuleDisableRequest: ProviderRuleDisableRequest;
};
export type PostV2ProviderRulesByRuleIdForkApiResponse =
  /** status 200 OK */ ProviderRuleForkResponse;
export type PostV2ProviderRulesByRuleIdForkApiArg = {
  ruleId: string;
  providerRuleForkRequest: ProviderRuleForkRequest;
};
export type PostV2ProviderRulesByRuleIdRevertApiResponse =
  /** status 200 OK */ ProviderRuleUpdateResponse;
export type PostV2ProviderRulesByRuleIdRevertApiArg = {
  ruleId: string;
  providerRuleRevertRequest: ProviderRuleRevertRequest;
};
export type GetV2ProviderRulesByRuleIdRevisionsApiResponse =
  /** status 200 OK */ ProviderRuleRevisionsResponse;
export type GetV2ProviderRulesByRuleIdRevisionsApiArg = {
  ruleId: string;
};
export type ListResponse = {
  items: any[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type ComplianceRuleDocument = {
  /** List of CPT codes this rule applies to */
  applicable_cpt_codes?: string[];
  /** Rationale for why this rule exists */
  compliance_rationale: string;
  /** Compliance criterion for the rule */
  criterion: string;
  /** Specific format or wording requirements */
  format_or_wording_required?: string | null;
  /** Organization ID that owns this rule */
  organization_id: string;
  /** Payer type (e.g., 'general', 'medicare', 'medicaid') */
  payer_type: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Full text description of the rule */
  rule_text: string;
  /** Type of rule (e.g., 'general', 'payer_specific') */
  rule_type: string;
  /** Date of source document (ISO format) */
  source_date?: string | null;
  /** Source document name */
  source_document?: string | null;
  /** Tags for categorization */
  tags?: string[];
  /** Human-readable title of the rule */
  title?: string | null;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
};
export type RuleResponse = {
  /** Rule document */
  rule: ComplianceRuleDocument;
  /** Rule ID */
  rule_id: string;
  /** Last update timestamp */
  updated_at?: string | null;
};
export type ComplianceRuleDocument2 = {
  /** List of CPT codes this rule applies to */
  applicable_cpt_codes?: string[];
  /** Rationale for why this rule exists */
  compliance_rationale: string;
  /** Compliance criterion for the rule */
  criterion: string;
  /** Specific format or wording requirements */
  format_or_wording_required?: string | null;
  /** Organization ID that owns this rule */
  organization_id: string;
  /** Payer type (e.g., 'general', 'medicare', 'medicaid') */
  payer_type: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Full text description of the rule */
  rule_text: string;
  /** Type of rule (e.g., 'general', 'payer_specific') */
  rule_type: string;
  /** Date of source document (ISO format) */
  source_date?: string | null;
  /** Source document name */
  source_document?: string | null;
  /** Tags for categorization */
  tags?: string[];
  /** Human-readable title of the rule */
  title?: string | null;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
};
export type CreateRuleRequest = {
  /** Rule document to create */
  rule: ComplianceRuleDocument2;
  /** User ID making this update */
  updated_by?: string | null;
};
export type RuleOwnerScope = "public" | "org" | "user";
export type ComplianceRuleDocument3 = {
  /** List of CPT codes this rule applies to */
  applicable_cpt_codes?: string[];
  /** Rationale for why this rule exists */
  compliance_rationale: string;
  /** Compliance criterion for the rule */
  criterion: string;
  /** Specific format or wording requirements */
  format_or_wording_required?: string | null;
  /** Organization ID that owns this rule */
  organization_id: string;
  /** Payer type (e.g., 'general', 'medicare', 'medicaid') */
  payer_type: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Full text description of the rule */
  rule_text: string;
  /** Type of rule (e.g., 'general', 'payer_specific') */
  rule_type: string;
  /** Date of source document (ISO format) */
  source_date?: string | null;
  /** Source document name */
  source_document?: string | null;
  /** Tags for categorization */
  tags?: string[];
  /** Human-readable title of the rule */
  title?: string | null;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
};
export type ComplianceRuleRecord = {
  /** Creation timestamp (UTC) */
  created_at: string;
  /** Current published version number */
  current_version?: number;
  /** Soft delete timestamp, null when active */
  deleted_at?: string | null;
  /** Vector embedding (may be null until generated) */
  embedding?: number[] | null;
  /** Owning organization UUID when not public */
  organization_id?: string | null;
  /** Scope of the rule: public, org, or user */
  owner_scope?: RuleOwnerScope;
  /** Reference to parent rule when forked, for lineage tracking */
  parent_rule_id?: string | null;
  /** Rule payload from rule_data jsonb */
  rule: ComplianceRuleDocument3;
  /** UUID of the rule record */
  rule_id: string;
  /** Last update timestamp (UTC) */
  updated_at: string;
  /** User ID for user-scoped rules */
  user_id?: string | null;
};
export type RuleSearchResult = {
  /** Preview snippet from the matching rule */
  content_preview?: string | null;
  /** Additional metadata about the match */
  metadata?: {
    [key: string]: any;
  };
  /** Matched rule record */
  record: ComplianceRuleRecord;
  /** Optional relevance score from vector or text search */
  score?: number | null;
};
export type RuleSearchResponse = {
  /** The original search query */
  query: string;
  /** Search results */
  results?: RuleSearchResult[];
  /** Total number of results returned */
  total_results: number;
};
export type RuleOwnerScope2 = "public" | "org" | "user";
export type RuleSearchFilters = {
  /** Filter by CPT codes (any match) */
  cpt?: string[] | null;
  /** Filter by organization ID */
  organization_id?: string | null;
  /** Filter by owner scope (public, org, user) */
  owner_scope?: RuleOwnerScope2 | null;
  /** Filter by payer type */
  payer_type?: string | null;
  /** Filter by rule type */
  rule_type?: string | null;
  /** Filter by tags (all must match) */
  tags?: string[] | null;
  /** Plain-text fallback query when embeddings are unavailable */
  text?: string | null;
  /** Filter by user ID (for user-scoped rules) */
  user_id?: string | null;
};
export type RuleSearchRequest = {
  /** Optional filters for organization, rule type, payer type, CPT codes */
  filters?: RuleSearchFilters | null;
  /** Search query text */
  query: string;
  /** Number of top results to return */
  top_k?: number;
};
export type RuleNotFoundResponse = {
  /** Error message */
  error: string;
  /** Organization ID */
  org_id: string;
  /** Rule ID */
  rule_id: string;
};
export type ComplianceRuleDocument4 = {
  /** List of CPT codes this rule applies to */
  applicable_cpt_codes?: string[];
  /** Rationale for why this rule exists */
  compliance_rationale: string;
  /** Compliance criterion for the rule */
  criterion: string;
  /** Specific format or wording requirements */
  format_or_wording_required?: string | null;
  /** Organization ID that owns this rule */
  organization_id: string;
  /** Payer type (e.g., 'general', 'medicare', 'medicaid') */
  payer_type: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Full text description of the rule */
  rule_text: string;
  /** Type of rule (e.g., 'general', 'payer_specific') */
  rule_type: string;
  /** Date of source document (ISO format) */
  source_date?: string | null;
  /** Source document name */
  source_document?: string | null;
  /** Tags for categorization */
  tags?: string[];
  /** Human-readable title of the rule */
  title?: string | null;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
};
export type UpdateRuleRequest = {
  /** Updated rule document */
  rule: ComplianceRuleDocument4;
  /** User ID making this update */
  updated_by?: string | null;
};
export type ComplianceRuleDocument5 = {
  /** List of CPT codes this rule applies to */
  applicable_cpt_codes?: string[];
  /** Rationale for why this rule exists */
  compliance_rationale: string;
  /** Compliance criterion for the rule */
  criterion: string;
  /** Specific format or wording requirements */
  format_or_wording_required?: string | null;
  /** Organization ID that owns this rule */
  organization_id: string;
  /** Payer type (e.g., 'general', 'medicare', 'medicaid') */
  payer_type: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Full text description of the rule */
  rule_text: string;
  /** Type of rule (e.g., 'general', 'payer_specific') */
  rule_type: string;
  /** Date of source document (ISO format) */
  source_date?: string | null;
  /** Source document name */
  source_document?: string | null;
  /** Tags for categorization */
  tags?: string[];
  /** Human-readable title of the rule */
  title?: string | null;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
};
export type LearningRuleDocument = {
  /** Succinct explanation of why this matters clinically */
  clinical_rationale: string;
  /** Organization ID that owns this rule (can be 'global') */
  organization_id: string;
  /** Specific clinician-facing actions, reflections, or options to consider when this guidance applies */
  recommended_actions: string;
  /** Concise paragraph describing populations, diagnoses, modalities, symptoms, settings, and key phrases that signal when this learning rule matters */
  relevant_context: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Formatted citation string if available */
  source_citation?: string | null;
  /** Publication year or full date as YYYY or YYYY-MM-DD if known */
  source_date?: string | null;
  /** Primary source title or identifier */
  source_document?: string | null;
  /** Clickable URL to the source (e.g., DOI link) or null */
  source_link?: string | null;
  /** 2-4 sentence, high-yield summary of the key takeaway for clinicians */
  teaching_summary: string;
  /** Human-readable title of the learning rule */
  title: string;
  /** Type of rule (always 'learning') */
  type?: string;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
  /** Clinician-facing guidance for when this learning should be applied */
  when_to_follow: string;
};
export type ProviderRuleResponse = {
  /** Whether this rule is disabled for the requesting org/user */
  is_disabled?: boolean;
  /** Whether this is a global rule */
  is_global: boolean;
  /** Organization ID if not global */
  organization_id?: string | null;
  /** Rule document (compliance or learning) */
  rule: ComplianceRuleDocument5 | LearningRuleDocument;
  /** Rule ID */
  rule_id: string;
  /** Type of rule: 'compliance' or 'learning' */
  rule_type: "compliance" | "learning";
};
export type ProviderRuleListResponse = {
  items: ProviderRuleResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type RuleScope = "global" | "org" | "both";
export type RuleType = "compliance" | "learning";
export type RuleType2 = "compliance" | "learning";
export type ProviderRuleCreateResponse = {
  /** Timestamp of creation */
  created_at?: string | null;
  /** Organization ID of the created rule */
  organization_id: string;
  /** ID of the created rule */
  rule_id: string;
  /** Type of rule created */
  rule_type: RuleType2;
};
export type ComplianceRuleDocument6 = {
  /** List of CPT codes this rule applies to */
  applicable_cpt_codes?: string[];
  /** Rationale for why this rule exists */
  compliance_rationale: string;
  /** Compliance criterion for the rule */
  criterion: string;
  /** Specific format or wording requirements */
  format_or_wording_required?: string | null;
  /** Organization ID that owns this rule */
  organization_id: string;
  /** Payer type (e.g., 'general', 'medicare', 'medicaid') */
  payer_type: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Full text description of the rule */
  rule_text: string;
  /** Type of rule (e.g., 'general', 'payer_specific') */
  rule_type: string;
  /** Date of source document (ISO format) */
  source_date?: string | null;
  /** Source document name */
  source_document?: string | null;
  /** Tags for categorization */
  tags?: string[];
  /** Human-readable title of the rule */
  title?: string | null;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
};
export type LearningRuleDocument2 = {
  /** Succinct explanation of why this matters clinically */
  clinical_rationale: string;
  /** Organization ID that owns this rule (can be 'global') */
  organization_id: string;
  /** Specific clinician-facing actions, reflections, or options to consider when this guidance applies */
  recommended_actions: string;
  /** Concise paragraph describing populations, diagnoses, modalities, symptoms, settings, and key phrases that signal when this learning rule matters */
  relevant_context: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Formatted citation string if available */
  source_citation?: string | null;
  /** Publication year or full date as YYYY or YYYY-MM-DD if known */
  source_date?: string | null;
  /** Primary source title or identifier */
  source_document?: string | null;
  /** Clickable URL to the source (e.g., DOI link) or null */
  source_link?: string | null;
  /** 2-4 sentence, high-yield summary of the key takeaway for clinicians */
  teaching_summary: string;
  /** Human-readable title of the learning rule */
  title: string;
  /** Type of rule (always 'learning') */
  type?: string;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
  /** Clinician-facing guidance for when this learning should be applied */
  when_to_follow: string;
};
export type RuleType3 = "compliance" | "learning";
export type ProviderRuleCreateRequest = {
  /** Rule document to create */
  rule: ComplianceRuleDocument6 | LearningRuleDocument2;
  /** Type of rule: 'compliance' or 'learning' */
  rule_type: RuleType3;
};
export type ProviderRuleSearchResponse = {
  /** The original search query */
  query: string;
  /** Search results (mixed compliance and learning rules) */
  results?: {
    [key: string]: any;
  }[];
  /** Total number of results returned */
  total_results: number;
};
export type RuleType4 = "compliance" | "learning";
export type RuleType5 = "compliance" | "learning";
export type ProviderRuleDeleteResponse = {
  /** Whether deletion was successful */
  deleted: boolean;
  /** ID of the deleted rule */
  rule_id: string;
  /** Type of rule deleted */
  rule_type: RuleType5;
};
export type ComplianceRuleDocument7 = {
  /** List of CPT codes this rule applies to */
  applicable_cpt_codes?: string[];
  /** Rationale for why this rule exists */
  compliance_rationale: string;
  /** Compliance criterion for the rule */
  criterion: string;
  /** Specific format or wording requirements */
  format_or_wording_required?: string | null;
  /** Organization ID that owns this rule */
  organization_id: string;
  /** Payer type (e.g., 'general', 'medicare', 'medicaid') */
  payer_type: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Full text description of the rule */
  rule_text: string;
  /** Type of rule (e.g., 'general', 'payer_specific') */
  rule_type: string;
  /** Date of source document (ISO format) */
  source_date?: string | null;
  /** Source document name */
  source_document?: string | null;
  /** Tags for categorization */
  tags?: string[];
  /** Human-readable title of the rule */
  title?: string | null;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
};
export type LearningRuleDocument3 = {
  /** Succinct explanation of why this matters clinically */
  clinical_rationale: string;
  /** Organization ID that owns this rule (can be 'global') */
  organization_id: string;
  /** Specific clinician-facing actions, reflections, or options to consider when this guidance applies */
  recommended_actions: string;
  /** Concise paragraph describing populations, diagnoses, modalities, symptoms, settings, and key phrases that signal when this learning rule matters */
  relevant_context: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Formatted citation string if available */
  source_citation?: string | null;
  /** Publication year or full date as YYYY or YYYY-MM-DD if known */
  source_date?: string | null;
  /** Primary source title or identifier */
  source_document?: string | null;
  /** Clickable URL to the source (e.g., DOI link) or null */
  source_link?: string | null;
  /** 2-4 sentence, high-yield summary of the key takeaway for clinicians */
  teaching_summary: string;
  /** Human-readable title of the learning rule */
  title: string;
  /** Type of rule (always 'learning') */
  type?: string;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
  /** Clinician-facing guidance for when this learning should be applied */
  when_to_follow: string;
};
export type ProviderRuleResponse2 = {
  /** Whether this rule is disabled for the requesting org/user */
  is_disabled?: boolean;
  /** Whether this is a global rule */
  is_global: boolean;
  /** Organization ID if not global */
  organization_id?: string | null;
  /** Rule document (compliance or learning) */
  rule: ComplianceRuleDocument7 | LearningRuleDocument3;
  /** Rule ID */
  rule_id: string;
  /** Type of rule: 'compliance' or 'learning' */
  rule_type: "compliance" | "learning";
};
export type RuleType6 = "compliance" | "learning";
export type ProviderRuleUpdateResponse = {
  /** ID of the updated rule */
  rule_id: string;
  /** Type of rule updated */
  rule_type: RuleType6;
  /** Timestamp of update */
  updated_at?: string | null;
};
export type ComplianceRuleDocument8 = {
  /** List of CPT codes this rule applies to */
  applicable_cpt_codes?: string[];
  /** Rationale for why this rule exists */
  compliance_rationale: string;
  /** Compliance criterion for the rule */
  criterion: string;
  /** Specific format or wording requirements */
  format_or_wording_required?: string | null;
  /** Organization ID that owns this rule */
  organization_id: string;
  /** Payer type (e.g., 'general', 'medicare', 'medicaid') */
  payer_type: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Full text description of the rule */
  rule_text: string;
  /** Type of rule (e.g., 'general', 'payer_specific') */
  rule_type: string;
  /** Date of source document (ISO format) */
  source_date?: string | null;
  /** Source document name */
  source_document?: string | null;
  /** Tags for categorization */
  tags?: string[];
  /** Human-readable title of the rule */
  title?: string | null;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
};
export type LearningRuleDocument4 = {
  /** Succinct explanation of why this matters clinically */
  clinical_rationale: string;
  /** Organization ID that owns this rule (can be 'global') */
  organization_id: string;
  /** Specific clinician-facing actions, reflections, or options to consider when this guidance applies */
  recommended_actions: string;
  /** Concise paragraph describing populations, diagnoses, modalities, symptoms, settings, and key phrases that signal when this learning rule matters */
  relevant_context: string;
  /** Unique stable identifier for the rule */
  rule_id: string;
  /** Formatted citation string if available */
  source_citation?: string | null;
  /** Publication year or full date as YYYY or YYYY-MM-DD if known */
  source_date?: string | null;
  /** Primary source title or identifier */
  source_document?: string | null;
  /** Clickable URL to the source (e.g., DOI link) or null */
  source_link?: string | null;
  /** 2-4 sentence, high-yield summary of the key takeaway for clinicians */
  teaching_summary: string;
  /** Human-readable title of the learning rule */
  title: string;
  /** Type of rule (always 'learning') */
  type?: string;
  /** ISO timestamp of last update */
  updated_at?: string | null;
  /** User ID who last updated this rule */
  updated_by?: string | null;
  /** Clinician-facing guidance for when this learning should be applied */
  when_to_follow: string;
};
export type RuleType7 = "compliance" | "learning";
export type ProviderRuleUpdateRequest = {
  /** Updated rule document */
  rule: ComplianceRuleDocument8 | LearningRuleDocument4;
  /** Type of rule: 'compliance' or 'learning' */
  rule_type: RuleType7;
};
export type ProviderRuleDisableResponse = {
  /** Whether the rule is now disabled */
  disabled: boolean;
  /** ID of the rule */
  rule_id: string;
  /** Scope at which the rule was disabled/enabled */
  scope: string;
};
export type ProviderRuleDisableRequest = {
  /** Scope to disable at: 'org' or 'user' */
  scope?: "org" | "user";
};
export type ProviderRuleForkResponse = {
  /** ID of the newly created forked rule */
  new_rule_id: string;
  /** Organization ID of the forked rule */
  organization_id: string;
  /** Whether the source rule was disabled */
  source_disabled: boolean;
  /** ID of the source rule that was forked */
  source_rule_id: string;
  /** Scope of the forked rule (org or user) */
  target_scope: string;
};
export type ProviderRuleForkRequest = {
  /** Whether to automatically disable the source rule for this org/user */
  auto_disable_source?: boolean;
  /** Target scope for the forked rule: 'org' or 'user' */
  target_scope?: "org" | "user";
};
export type ProviderRuleRevertRequest = {
  /** Version number to revert to */
  version: number;
};
export type ProviderRuleRevisionResponse = {
  /** When this revision was created */
  created_at: string;
  /** User who created this revision */
  created_by: string;
  /** Rule data at this version */
  rule_data: {
    [key: string]: any;
  };
  /** Rule ID */
  rule_id: string;
  /** Version number */
  version: number;
};
export type ProviderRuleRevisionsResponse = {
  /** List of revisions ordered by version descending */
  revisions?: ProviderRuleRevisionResponse[];
  /** Rule ID */
  rule_id: string;
  /** Total number of revisions */
  total: number;
};
